export default function MainContainer({
  width = 5,
  children,
}: React.PropsWithChildren & { width?: number }) {
  return (
    <main className={`mx-auto max-w-${width}xl py-6 px-4 sm:px-6 lg:px-8`}>
      {children}
    </main>
  )
}
